import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadow.default};
`;

export const TitleContainer = styled.div`
  height: 32px;
  position: relative;
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.colors.gray[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: none;
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -24px;
  height: 56px;
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.orange.primary};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.2);

  h2 {
    font-weight: 600;
    font-size: 18px;
    text-align: center;
  }

  span {
    position: absolute;
    right: 10px;
    font-size: 20px;
    height: 20px;
    padding: 0 10px;
    cursor: pointer;
    font-weight: 600;

    &:hover {
      opacity: 0.75;
    }
  }
`;

export const CustomTableContainer = styled.div<{hasCheckbox: boolean}>`
  overflow-x: auto;
  border-radius: 0 0 16px 16px;

  table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    -webkit-border-radius: 0 0 8px 8px;
    -moz-border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  th {
    padding: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    background-color: ${({ theme }) => theme.colors.white};

    text-align: center;
    height: 52px;
  }
  th:first-child span {
    ${({hasCheckbox}) => hasCheckbox ? "margin-left: 32px !important;" : ""}
  }

  td {
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    font-family: 'Poppins';
    line-height: 24px;
    max-width: 120px;

    .table-tooltip {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    button {
      border: none;
      background: transparent;
      color: #f58220;
      font-weight: 500;
      text-decoration: underline;
      transition: filter 0.2s;
      &:hover {
        filter: brightness(0.8);
      }
    }

    span {
      font-weight: 700;
      font-size: 10px;
      line-height: 24px;
      color: #ffffff;
      padding: 0 18px;
      border-radius: 4px;

      &.warning {
        background-color: var(--warning-color);
      }

      &.info {
        background-color: var(--info-color);
      }

      &.danger {
        background-color: var(--danger-color);
      }

      &.success {
        background-color: var(--success-color);
      }
    }
  }

  tr {
    height: 48px;
  }

  tr:nth-child(1) {
    border-top: none;
  }

  tr:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.gray.table};
  }

  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
